import React from 'react'
const PageTitle = ({ PageTitle }) => {

    return (
        <div className='py-2 fw-bold'>{PageTitle}</div>
    )
}
export { PageTitle }